var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { AfyChipFilter, AfyEditableTable } from "@affinitysystemsgroup/assurehub-ui";
import { GlobalPanelCard, GlobalPanelEmpty, GlobalPanelFilterWrap, GlobalPanelLabel, GlobalPanelNote, GlobalPanelScroll, } from "../style/globalPropertiesPanel.style";
import { useGlobalPropertiesPanel } from "../hook/globalPropertiesPanel.hook";
import { getEntityLabel } from "../../../constants/properties.constants";
export var GlobalPropertiesPanelView = function (props) {
    var p = useGlobalPropertiesPanel(props);
    return (_jsxs(GlobalPanelCard, { children: [_jsxs(GlobalPanelLabel, { children: [props.titlePrefix, " ", props.categoryLabel || "—"] }), props.rows.length === 0 && !props.loading ? (_jsx(GlobalPanelEmpty, { children: props.emptyText })) : (_jsxs(React.Fragment, { children: [props.entityFilterOptions.length > 0 && (_jsx(GlobalPanelFilterWrap, { children: _jsx(AfyChipFilter, { options: __spreadArray([
                                { value: props.allLabel, label: props.allLabel }
                            ], props.entityFilterOptions.map(function (entity) { return ({
                                value: entity,
                                label: getEntityLabel(entity),
                            }); }), true), value: props.entityFilter, onChange: props.onChangeEntityFilter }) })), _jsx(GlobalPanelScroll, { children: _jsx(AfyEditableTable, { columns: p.columns, rows: p.rows, onSave: p.onSaveRow, emptyMessage: props.emptyText }) }), _jsx(GlobalPanelNote, { children: props.note })] }))] }));
};
export default GlobalPropertiesPanelView;
